import { Col, Form, Row, Switch, TimePicker } from 'antd';
import dayjs from 'dayjs';
import { useContext } from 'react';

import { schedule } from '@app/components/Schedule/data/schedule';
import type { ScheduleMain } from '@app/components/Schedule/types';
import { PREFIX } from '@app/constants';
import { NotificationContext } from '@app/providers';
import { correctTimeInterval } from '@app/utils';

import '@app/components/Schedule/styles/Schedule.desktop.scss';

export const Schedule = ({ form }: ScheduleMain) => {
  const { showNotification } = useContext(NotificationContext);

  return (
    <div className={`${PREFIX}sendout-message-modal-schedule-container`}>
      {schedule.map((day) => {
        return (
          <Form.Item key={day.label} noStyle>
            <Row align="middle" gutter={[16, 32]}>
              <Col span={7}>
                <span>{day.title}</span>
              </Col>
              <Col span={4}>
                <Form.Item
                  name={['schedule', day.label, 'active']}
                  valuePropName="checked"
                  noStyle
                >
                  <Switch
                    onChange={(checked) => {
                      if (checked) {
                        form.setFieldsValue({
                          schedule: {
                            [day.label]: {
                              startTime: dayjs('09:00', 'HH:mm'),
                              endTime: dayjs('20:00', 'HH:mm'),
                            },
                          },
                        });
                      } else {
                        form.setFieldsValue({
                          schedule: {
                            [day.label]: {
                              startTime: null,
                              endTime: null,
                            },
                          },
                        });
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.schedule[day.label]?.active !==
                    currentValues.schedule[day.label]?.active
                  }
                  noStyle
                >
                  {() => (
                    <Form.Item
                      name={['schedule', day.label, 'startTime']}
                      noStyle
                    >
                      <TimePicker
                        format="HH:mm"
                        placeholder="09:00"
                        disabled={
                          !form.getFieldValue(['schedule', day.label, 'active'])
                        }
                        onChange={(time, timeString) => {
                          if (typeof timeString !== 'string') return;

                          correctTimeInterval({
                            inputStart: {
                              value: timeString,
                              label: timeString,
                            },
                            inputEnd: {
                              value: dayjs(
                                form.getFieldValue([
                                  'schedule',
                                  day.label,
                                  'endTime',
                                ])
                              ).format('HH:mm'),
                              label: dayjs(
                                form.getFieldValue([
                                  'schedule',
                                  day.label,
                                  'endTime',
                                ])
                              ).format('HH:mm'),
                            },
                            showNotification,
                            cbToSaveBothValues: ([startTime, endTime]) => {
                              form.setFieldValue(
                                ['schedule', day.label, 'startTime'],
                                dayjs(startTime.value, 'HH:mm')
                              );
                              form.setFieldValue(
                                ['schedule', day.label, 'endTime'],
                                dayjs(endTime.value, 'HH:mm')
                              );
                            },
                          });
                        }}
                      />
                    </Form.Item>
                  )}
                </Form.Item>
              </Col>
              <Col span={1}>–</Col>
              <Col span={6}>
                <Form.Item
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.schedule[day.label]?.active !==
                    currentValues.schedule[day.label]?.active
                  }
                  noStyle
                >
                  {() => (
                    <Form.Item
                      name={['schedule', day.label, 'endTime']}
                      noStyle
                    >
                      <TimePicker
                        format="HH:mm"
                        placeholder="20:00"
                        disabled={
                          !form.getFieldValue(['schedule', day.label, 'active'])
                        }
                        onChange={(time, timeString) => {
                          if (typeof timeString !== 'string') return;

                          correctTimeInterval({
                            inputStart: {
                              value: dayjs(
                                form.getFieldValue([
                                  'schedule',
                                  day.label,
                                  'startTime',
                                ])
                              ).format('HH:mm'),
                              label: dayjs(
                                form.getFieldValue([
                                  'schedule',
                                  day.label,
                                  'startTime',
                                ])
                              ).format('HH:mm'),
                            },
                            inputEnd: {
                              value: timeString,
                              label: timeString,
                            },
                            showNotification,
                            cbToSaveBothValues: ([startTime, endTime]) => {
                              form.setFieldValue(
                                ['schedule', day.label, 'startTime'],
                                dayjs(startTime.value, 'HH:mm')
                              );
                              form.setFieldValue(
                                ['schedule', day.label, 'endTime'],
                                dayjs(endTime.value, 'HH:mm')
                              );
                            },
                          });
                        }}
                      />
                    </Form.Item>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form.Item>
        );
      })}
    </div>
  );
};
